import {
  mdiExclamationThick,
  mdiViewDashboardVariant,
  mdiClipboardOutline,
  mdiCertificate,
  mdiScaleBalance,
  mdiAccountGroup,
  mdiOfficeBuilding,
  mdiFileDocument,
  mdiWrench,
  mdiWarehouse,
  mdiPowerPlug,
  mdiCog,
  mdiCogs,
  mdiAccount,
  mdiAccountCog,
  mdiBell,
  mdiRss,
  mdiBriefcaseVariant,
  mdiCalendarMonth,
  mdiEmailOutline,
  mdiSpeedometer,
  mdiAlertDecagram,
  mdiAlertOutline,
  mdiShieldAlertOutline,
  mdiShieldLockOpenOutline,
  mdiAutoFix,
  mdiAccountMultiple,
  mdiCurrencyEur,
  mdiPackageVariantClosed,
  mdiShuffleVariant,
  mdiApplicationCog,
  mdiFilter,
  mdiTag,
  mdiFile,
  mdiTextBox,
  mdiOfficeBuildingCog,
  mdiHistory,
  mdiTranslate,
  mdiBullhorn,
  mdiOwl,
  mdiTextBoxOutline,
} from "@mdi/js";

const ACCOUNT = -1;
const LICENSE = -5;
const PUBLIC_ISSUES = -6;

const MAIN_DASHBOARD_SCREENS = 1;
const MAIN_ISSUES = 2;
const MAIN_PERSONS = 3;
const MAIN_ASSETS = 4;
const MAIN_DOCUMENTS = 5;
const MAIN_SERVICES = 6;
const MAIN_RISK_MANAGEMENT = 7;
const MAIN_AUDITS = 8;
const MAIN_WAREHOUSES = 9;
const MAIN_CONNECTORS = 10;
const MAIN_SETTINGS = 11;
const MAIN_ADMINISTRATION = 12;
const MAIN_IMPLEMENTATION = 13;
const ACTIVITIES = 14;
const ASSET_CATEGORIES = 15;
const ASSET_GROUPS = 18;
const ASSETS = 21;
const ASSETS_TAB_NETWORK_GRAPH = 27;
const ASSETS_TAB_CONTROLS = 181;
const AUDITS = 32;
const AUTOMATED_ACTIONS = 36;
const BACKGROUND_JOBS = 39;
const CONNECTORS = 40;
const CONSEQUENCES = 42;
const CONTRACTS = 43;
const CONTROLS = 45;
const CONTROLS_MANAGEMENT = 46;
const DASHBOARD_SCREENS = 47;
const DATA_SETS = 48;
const DOCUMENTS = 51;
const EXTERNAL_EMAILS = 53;
const FIELDS = 55;
const HOLIDAYS = 58;
const IMPORT_ASSETS = 59;
const IMPORT_CONTRACTS = 60;
const IMPORT_CONTROLS = 61;
const IMPORT_DOCUMENTS = 62;
const IMPORT_FIELDS = 63;
const IMPORT_HOLIDAYS = 64;
const IMPORT_ISSUE_PRIORITIES = 65;
const IMPORT_ISSUES = 67;
const IMPORT_PERSON_RELATIONS = 68;
const IMPORT_PERSONS = 69;
const IMPORT_PRICE_ITEMS = 70;
const IMPORT_PRICE_LISTS = 71;
const IMPORT_RULES = 72;
const IMPORT_SERVICES = 73;
const IMPORT_STANDARDS = 74;
const IMPORT_TAG_DEFINITIONS = 75;
const IMPORT_THREATS = 76;
const IMPORT_TRANSLATIONS = 77;
const IMPORT_USERS = 78;
const IMPORT_VULNERABILITIES = 79;
const IMPORT_WAREHOUSES = 80;
const APP_SETTINGS = 81;
const ISSUE_PRIORITIES = 82;
const ISSUES = 84;
const KPIS = 93;
const LIKELIHOODS = 97;
const MAINTENANCE_PLAN = 100;
const MAPPERS = 101;
const NOTICE = 104;
const NOTIFICATIONS = 105;
const PERSON_CATEGORIES = 107;
const PERSON_RELATIONS = 109;
const PERSONS = 110;
const PLANNING_CALENDAR = 117;
const PRICE_ITEMS = 118;
const PRICE_LISTS = 121;
const REPORTS = 127;
const RISK_LEVELS = 128;
const RISKS = 129;
const ROLES = 130;
const RULES = 135;
const SERVICES = 138;
const SNIPPETS = 146;
const STANDARD_SOAS = 147;
const STANDARDS = 149;
const STANDBY_PLAN = 151;
const STATISTICS = 152;
const SUBSCRIPTIONS = 153;
const TAG_DEFINITIONS = 155;
const THREATS = 156;
const TRANSLATIONS = 158;
const USERS = 160;
const VULNERABILITIES = 161;
const WAREHOUSES = 163;
const TEAMS = 170;
const THREAT_CATEGORIES = 180;
const IMPORT_THREAT_CATEGORIES = 183;
const PORTAL = 1001;
const FEEDBACK = 1002;
const KNOWLEDGE_BASE = 1003;

const APP_MENU = Object.freeze([
  {
    perms_name: MAIN_DASHBOARD_SCREENS,
    title_t: "dashboard_screen.dashboard_screens",
    multiple: true,
    noSetter: true,
    icon: mdiViewDashboardVariant,
    items: [
      {
        title_t: "dashboard_screen.dashboard_screens",
        perms_name: DASHBOARD_SCREENS,
        icon: mdiViewDashboardVariant,
        url: "dashboard_screens",
        tooltip: "Shift + B",
      },
      {
        title_t: "kpi.kpi",
        perms_name: KPIS,
        icon: mdiSpeedometer,
        url: "kpis",
      },
    ],
  },
  {
    perms_name: MAIN_ISSUES,
    title_t: "issue.issues",
    multiple: true,
    noSetter: true,
    icon: mdiClipboardOutline,
    items: [
      {
        title_t: "issue.issues",
        perms_name: ISSUES,
        icon: mdiClipboardOutline,
        url: "issues",
        tooltip: "Shift + I",
      },
      {
        title_t: "calendar.planning_calendar",
        perms_name: PLANNING_CALENDAR,
        url: "planning_calendar",
        tooltip: "Shift + C",
        icon: mdiCalendarMonth,
      },
      // {
      //   title_t: "task.tasks",
      //   perms_name: TASKS,
      //   url: "tasks",
      //   icon: mdiClipboardOutline,
      // },
    ],
  },
  {
    perms_name: MAIN_PERSONS,
    title_t: "person.persons",
    multiple: true,
    noSetter: true,
    icon: mdiAccountGroup,
    items: [
      {
        title_t: "person.persons",
        perms_name: PERSONS,
        icon: mdiAccountGroup,
        url: "persons",
        tooltip: "Shift + P",
      },
      {
        title_t: "category.categories",
        perms_name: PERSON_CATEGORIES,
        icon: mdiAccountCog,
        url: "person_categories",
      },
      {
        title_t: "role.roles",
        perms_name: ROLES,
        url: "roles",
        icon: mdiAccountMultiple,
      },
      {
        title_t: "team.teams",
        perms_name: TEAMS,
        url: "teams",
        icon: mdiAccountMultiple,
      },
      {
        title_t: "user.users",
        perms_name: USERS,
        icon: mdiAccount,
        url: "users",
      },
    ],
  },
  {
    perms_name: MAIN_ASSETS,
    title_t: "asset.assets",
    multiple: true,
    noSetter: true,
    icon: mdiOfficeBuilding,
    items: [
      {
        title_t: "asset.assets",
        perms_name: ASSETS,
        url: "assets",
        tooltip: "Shift + A",
        icon: mdiOfficeBuilding,
      },
      {
        title_t: "asset_group.asset_groups",
        perms_name: ASSET_GROUPS,
        icon: mdiCog,
        url: "asset_groups",
      },

      {
        title_t: "category.categories",
        perms_name: ASSET_CATEGORIES,
        icon: mdiOfficeBuildingCog,
        url: "asset_categories",
      },
    ],
  },
  {
    perms_name: MAIN_DOCUMENTS,
    title_t: "document.documents",
    multiple: true,
    noSetter: true,
    icon: mdiFileDocument,
    items: [
      {
        title_t: "document.documents",
        perms_name: DOCUMENTS,
        icon: mdiFileDocument,
        url: "documents",
        tooltip: "Shift + D",
      },
    ],
  },
  {
    perms_name: MAIN_SERVICES,
    title_t: "service.services",
    multiple: true,
    noSetter: true,
    icon: mdiWrench,
    items: [
      {
        title_t: "service.services",
        perms_name: SERVICES,
        icon: mdiWrench,
        url: "services",
        tooltip: "Shift + S",
      },
      {
        title_t: "contract.contracts",
        perms_name: CONTRACTS,
        icon: mdiBriefcaseVariant,
        url: "contracts",
      },
      {
        title_t: "calendar.maintenance_plan",
        perms_name: MAINTENANCE_PLAN,
        url: "maintenance_plan",
        icon: mdiCalendarMonth,
      },
      {
        title_t: "service.label.standby_plan",
        perms_name: STANDBY_PLAN,
        url: "standby_plan",
        icon: mdiCalendarMonth,
      },
      {
        title_t: "rule.rules",
        perms_name: RULES,
        icon: mdiCalendarMonth,
        url: "rules",
      },
    ],
  },
  {
    perms_name: MAIN_RISK_MANAGEMENT,
    title_t: "risk_management.risk_management",
    multiple: true,
    noSetter: true,
    icon: mdiAlertDecagram,
    items: [
      {
        title_t: "risk.label.risk_analysis",
        perms_name: RISKS,
        icon: mdiCog,
        url: "risks",
      },
      {
        title_t: "controls_management.controls_management",
        perms_name: CONTROLS_MANAGEMENT,
        icon: mdiCog,
        url: "controls_management",
      },
      {
        title_t: "threat.threats",
        perms_name: THREATS,
        icon: mdiShieldAlertOutline,
        url: "threats",
      },
      {
        title_t: "threat_category.threat_categories",
        perms_name: THREAT_CATEGORIES,
        icon: mdiShieldAlertOutline,
        url: "threat_categories",
      },
      {
        title_t: "vulnerability.vulnerabilities",
        perms_name: VULNERABILITIES,
        icon: mdiShieldLockOpenOutline,
        url: "vulnerabilities",
      },
      {
        title_t: "control.controls",
        perms_name: CONTROLS,
        icon: mdiAlertOutline,
        url: "controls",
      },
      {
        title_t: "consequence.consequences",
        perms_name: CONSEQUENCES,
        icon: mdiShieldAlertOutline,
        url: "consequences",
      },
      {
        title_t: "likelihood.likelihoods",
        perms_name: LIKELIHOODS,
        icon: mdiShieldAlertOutline,
        url: "likelihoods",
      },
      {
        title_t: "risk_level.risk_levels",
        perms_name: RISK_LEVELS,
        icon: mdiShieldAlertOutline,
        url: "risk_levels",
      },
    ],
  },
  {
    perms_name: MAIN_AUDITS,
    title_t: "audit.audits",
    multiple: true,
    noSetter: true,
    icon: mdiCertificate,
    items: [
      {
        title_t: "audit.audits",
        perms_name: AUDITS,
        icon: mdiCertificate,
        url: "audits",
      },
      {
        title_t: "standard_soa.standard_soas",
        perms_name: STANDARD_SOAS,
        icon: mdiCertificate,
        url: "standard_soas",
      },
      {
        title_t: "standard.laws_standards",
        perms_name: STANDARDS,
        icon: mdiScaleBalance,
        url: "standards",
      },
    ],
  },
  {
    perms_name: MAIN_WAREHOUSES,
    title_t: "warehouse.warehouses",
    multiple: true,
    noSetter: true,
    icon: mdiWarehouse,
    items: [
      {
        title_t: "warehouse.warehouses",
        perms_name: WAREHOUSES,
        icon: mdiWarehouse,
        url: "warehouses",
        tooltip: "Shift + W",
      },
      {
        title_t: "price_list.price_lists",
        perms_name: PRICE_LISTS,
        icon: mdiCurrencyEur,
        url: "price_lists",
      },
      {
        title_t: "price_item.price_items",
        perms_name: PRICE_ITEMS,
        icon: mdiPackageVariantClosed,
        url: "price_items",
      },
    ],
  },
  {
    perms_name: MAIN_CONNECTORS,
    title_t: "connector.connectors",
    multiple: true,
    noSetter: true,
    icon: mdiPowerPlug,
    items: [
      {
        title_t: "connector.connectors",
        perms_name: CONNECTORS,
        icon: mdiPowerPlug,
        url: "connectors",
      },
      {
        title_t: "mapper.mappers",
        perms_name: MAPPERS,
        icon: mdiShuffleVariant,
        url: "mappers",
      },
      {
        title_t: "external_email.external_emails",
        perms_name: EXTERNAL_EMAILS,
        icon: mdiEmailOutline,
        url: "external_emails",
      },
    ],
  },
  {
    perms_name: KNOWLEDGE_BASE,
    title_t: "knowledge_base.knowledge_base",
    multiple: true,
    noSetter: true,
    icon: mdiOwl,
    items: [
      {
        title_t: "article.articles",
        perms_name: KNOWLEDGE_BASE,
        icon: mdiTextBoxOutline,
        url: "articles",
      },
    ],
  },
  {
    perms_name: MAIN_SETTINGS,
    title_t: "profile.settings",
    multiple: true,
    noSetter: true,
    icon: mdiAccountCog,
    items: [
      {
        title_t: "data_set.data_sets",
        perms_name: DATA_SETS,
        icon: mdiFilter,
        url: "data_sets",
      },
      {
        title_t: "snippet.snippets",
        perms_name: SNIPPETS,
        icon: mdiTextBox,
        url: "snippets",
      },
      {
        title_t: "notification.notifications",
        icon: mdiBell,
        url: "notifications",
        perms_name: NOTIFICATIONS,
      },
      {
        title_t: "subscription.subscriptions",
        icon: mdiRss,
        url: "subscriptions",
        perms_name: SUBSCRIPTIONS,
      },
    ],
  },
  {
    perms_name: MAIN_ADMINISTRATION,
    title_t: "administration.administration",
    multiple: true,
    noSetter: true,
    icon: mdiCog,
    items: [
      {
        title_t: "issue_priority.issue_priorities",
        url: "issue_priorities",
        perms_name: ISSUE_PRIORITIES,
        icon: mdiExclamationThick,
      },
      {
        title_t: "tag_definition.tag_definitions",
        perms_name: TAG_DEFINITIONS,
        icon: mdiTag,
        url: "tag_definitions",
      },
      {
        title_t: "person_relation.person_relations",
        url: "person_relations",
        perms_name: PERSON_RELATIONS,
        icon: mdiAccountGroup,
      },
      {
        title_t: "field.fields",
        perms_name: FIELDS,
        icon: mdiApplicationCog,
        url: "fields",
      },
      {
        title_t: "report.reports",
        perms_name: REPORTS,
        icon: mdiFile,
        url: "reports",
      },
      {
        title_t: "automated_action.automated_actions",
        perms_name: AUTOMATED_ACTIONS,
        url: "automated_actions",
        icon: mdiAutoFix,
      },
      {
        title_t: "translation.translations",
        perms_name: TRANSLATIONS,
        icon: mdiTranslate,
        url: "translations",
      },
      {
        title_t: "implementation.menu.notice",
        url: "notice",
        icon: mdiBullhorn,
        perms_name: NOTICE,
      },
      {
        title_t: "activity.activities",
        perms_name: ACTIVITIES,
        icon: mdiHistory,
        url: "activities",
      },
      {
        title_t: "license.license",
        url: "license",
        perms_name: LICENSE,
      },
    ],
  },
  {
    perms_name: MAIN_IMPLEMENTATION,
    title_t: "implementation.implementation",
    multiple: true,
    noSetter: true,
    icon: mdiCogs,
    items: [
      {
        title_t: "implementation.menu.app_settings",
        url: "app_settings",
        perms_name: APP_SETTINGS,
      },
      {
        title_t: "implementation.menu.statistics",
        url: "statistics",
        perms_name: STATISTICS,
      },
      {
        title_t: "implementation.menu.holidays",
        url: "holidays",
        perms_name: HOLIDAYS,
      },
      {
        title_t: "implementation.menu.background_jobs",
        url: "background_jobs",
        perms_name: BACKGROUND_JOBS,
      },
    ],
  },
]);

const PATH_TO_PERMISSION = {
  ...{
    "assets/import": IMPORT_ASSETS,
    "contracts/import": IMPORT_CONTRACTS,
    "controls/import": IMPORT_CONTROLS,
    "documents/import": IMPORT_DOCUMENTS,
    "fields/import": IMPORT_FIELDS,
    "holidays/import": IMPORT_HOLIDAYS,
    "issue_priorities/import": IMPORT_ISSUE_PRIORITIES,
    "issues/import": IMPORT_ISSUES,
    "person_relations/import": IMPORT_PERSON_RELATIONS,
    "persons/import": IMPORT_PERSONS,
    "price_items/import": IMPORT_PRICE_ITEMS,
    "price_lists/import": IMPORT_PRICE_LISTS,
    "rules/import": IMPORT_RULES,
    "services/import": IMPORT_SERVICES,
    "standards/import": IMPORT_STANDARDS,
    "tag_definitions/import": IMPORT_TAG_DEFINITIONS,
    "threats/import": IMPORT_THREATS,
    "threat_categories/import": IMPORT_THREAT_CATEGORIES,
    "translations/import": IMPORT_TRANSLATIONS,
    "users/import": IMPORT_USERS,
    "vulnerabilities/import": IMPORT_VULNERABILITIES,
    "warehouses/import": IMPORT_WAREHOUSES,
    "public/issues": PUBLIC_ISSUES,
    account: ACCOUNT,
    portal: PORTAL,
    knowledge_base: KNOWLEDGE_BASE,
    feedback: FEEDBACK,
  },
  ...Object.fromEntries(
    APP_MENU.flatMap((m) => m.items.map((i) => [i.url, i.perms_name]))
  ),
};

const NOT_PERMISSION_CHECKED_PARTS = Object.freeze([
  KNOWLEDGE_BASE,
  PORTAL,
  FEEDBACK,
]);

const LICENSE_CHECKED_PARTS = Object.freeze([
  ASSET_CATEGORIES,
  ASSETS_TAB_NETWORK_GRAPH,
  ASSETS_TAB_CONTROLS,
  ASSET_GROUPS,
  ASSETS,
  AUDITS,
  AUTOMATED_ACTIONS,
  CONSEQUENCES,
  CONTRACTS,
  CONTROLS_MANAGEMENT,
  CONTROLS,
  DOCUMENTS,
  FEEDBACK,
  ISSUES,
  KNOWLEDGE_BASE,
  KPIS,
  LIKELIHOODS,
  MAIN_ASSETS,
  MAIN_AUDITS,
  MAIN_DOCUMENTS,
  MAIN_RISK_MANAGEMENT,
  MAIN_SERVICES,
  MAIN_WAREHOUSES,
  MAINTENANCE_PLAN,
  PLANNING_CALENDAR,
  PORTAL,
  PRICE_ITEMS,
  PRICE_LISTS,
  RISK_LEVELS,
  RISKS,
  RULES,
  SERVICES,
  STANDARD_SOAS,
  STANDARDS,
  STANDBY_PLAN,
  THREATS,
  THREAT_CATEGORIES,
  VULNERABILITIES,
  WAREHOUSES,
]);

const MODELS = Object.freeze([
  "article",
  "asset",
  "asset_link",
  "assets_issue",
  "asset_group",
  "audit",
  "automated_action",
  "category",
  "category_hierarchy",
  "cia",
  "connector",
  "consequence",
  "contract",
  "control",
  "dashboard_screen",
  "dashlet",
  "data_set",
  "document",
  "entity_document",
  "entity_subscription",
  "external_email",
  "external_guid",
  "field",
  "field_assignment",
  "holiday",
  "issue",
  "issue_category",
  "issue_feedback",
  "issue_link",
  "issue_note",
  "issue_priority",
  "issue_service",
  "kpi",
  "likelihood",
  "location",
  "mapper",
  "person",
  "person_asset",
  "person_relation",
  "price_item",
  "price_items_price_list",
  "price_items_warehouse",
  "price_list",
  "provision",
  "provision_question",
  "question",
  "recommendation",
  "report",
  "requirement",
  "risk",
  "risk_control",
  "risk_level",
  "role",
  "role_user",
  "rule",
  "section",
  "service",
  "service_person",
  "sla",
  "snippet",
  "standard",
  "standard_soa",
  "standard_soa_provision",
  "standby_time",
  "subscription",
  "tag_assignment",
  "tag_definition",
  "task",
  "task_template",
  "task_user",
  "team",
  "team_user",
  "template_assignment",
  "threat",
  "threat_category",
  "translation",
  "user",
  "vulnerability",
  "warehouse",
  "warehouse_batch",
  "warehouse_transaction",
  "warehouse_transaction_item",
  "work_report",
]);

export {
  APP_MENU,
  MODELS,
  PATH_TO_PERMISSION,
  LICENSE_CHECKED_PARTS,
  NOT_PERMISSION_CHECKED_PARTS,
};
